/**
 * Converts Contentful's "NavItems" content type to the appropriate component
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import Navbar from 'components/Navbar'

const ContentfulNavItems = ({
  location, logo, logoUrl, links,
}) => (
  (logo) ? (
    <Navbar
      location={location}
      logoUrl={logoUrl}
      logo={logo?.src?.file?.url}
      alt={logo?.alt}
      buttons={links || []} />
  ) : null
)

ContentfulNavItems.propTypes = {
  logoUrl: PropTypes.string,
  location: PropTypes.object,
  logo: PropTypes.object,
  links: PropTypes.array,
}

export default ContentfulNavItems
